import * as yup from 'yup';

export const password = yup
	.string()
	.required('Påkrævet')
	.min(6, 'Minimum 6 tegn')
	.max(16, 'Maksimalt 16 tegn');
